<template>
    <li>
        <p v-html="message"></p>
        <p class="text-gray-500"><small>{{ formatedDate }}</small></p>
    </li>
</template>

<script>
import { DateTime } from "luxon";

export default {
    props: ['announcement'],

    computed: {
        message () {
            return this.announcement.message.replace(/(?:\r\n|\r|\n)/g, '<br>');
        },

        formatedDate () {
            if (!this.announcement.updated_at) {
                return '';
            }

            return DateTime.fromISO(this.announcement.updated_at).toLocaleString(DateTime.DATETIME_MED);
        },
    }
}
</script>

<style>

</style>